import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Gift } from 'lucide-react';
export function ProductContents() {
  return <Section background="light" data-id="element-176">
      <div className="text-center mb-10" data-id="element-177">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0f1923] mb-4" data-id="element-178">
          Qué incluye exactamente
        </h2>
        <p className="text-gray-600" data-id="element-179">
          Acceso inmediato al sistema completo en PDF
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-180">
        {/* Image Side */}
        <div className="relative order-2 lg:order-1" data-id="element-181">
          <div className="sticky top-24" data-id="element-182">
            <img src="https://cdn.magicpatterns.com/uploads/8Xmh8nvyuQfKczEyxCfCW8/mockoup_3.png" alt="Contenido del Plan Anti-Pantalla" className="w-full rounded-xl shadow-2xl" data-id="element-183" />
          </div>
        </div>

        {/* Content Side */}
        <div className="order-1 lg:order-2 space-y-8" data-id="element-184">
          {/* Main Product */}
          <div className="space-y-6" data-id="element-185">
            <h3 className="text-2xl font-bold text-[#0f1923] flex items-center gap-3" data-id="element-186">
              <span className="bg-[#0f1923] text-white w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-187">
                1
              </span>
              Plan Anti-Pantalla 30 Días
            </h3>
            <ul className="space-y-3 pl-4 border-l-2 border-gray-200" data-id="element-188">
              {['Diagnóstico por edades (4–6 / 7–10 / 11–15)', 'Preparación Días -3 a 0 (para evitar explosión)', 'Reglas mínimas que sí se cumplen', "Consecuencias 'aburridas' (las únicas sostenibles)", 'Menú de reemplazo por energía y edad', 'Protocolo de apagado de 10 minutos (frases exactas)', 'Plan por semanas + medición diaria', 'Manejo de mentiras, escondidas y crisis', 'Mantención: fines de semana, vacaciones, recaídas'].map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-189">
                  <CheckCircle2 className="w-5 h-5 text-[#c9a84c] flex-shrink-0 mt-0.5" data-id="element-190" />
                  <span data-id="element-191">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Bonuses */}
          <div className="bg-[#c9a84c]/10 p-8 rounded-2xl border border-[#c9a84c]/20" data-id="element-192">
            <h3 className="text-2xl font-bold text-[#0f1923] mb-6 flex items-center gap-3" data-id="element-193">
              <Gift className="w-6 h-6 text-[#c9a84c]" data-id="element-194" />
              Bonos Incluidos
            </h3>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-195">
              {['Checklist para la refri', 'Guiones por edad', 'Menú de reemplazo imprimible', 'Contrato familiar digital'].map((bonus, i) => <div key={i} className="bg-white p-4 rounded-lg shadow-sm text-sm font-medium text-[#1a2332]" data-id="element-196">
                  {bonus}
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </Section>;
}